import styled from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgType?: string;
}

export const Box = styled.div<IProps>`
  position: relative;
  width: ${mixin.pxToVw('300')};
  height: ${mixin.pxToVw('590')};
  background: ${({ $bgType }) => ($bgType === 'black' ? '#1A1A1A' : '#f6f6f6')};
  border-radius: 20px;

  .skeleton {
    border-radius: 4px;
    background: ${({ $bgType }) => ($bgType === 'black' ? '#333' : '#eee')};
  }

  .user-info {
    ${mixin.flex({ justify: 'flex-start', align: 'center' })};
    gap: 0 10px;
    padding: 14px;

    .user-img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
    }

    .user-name {
      width: 100px;
      height: 16px;
    }
  }

  .shortform-info {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 20px;

    .text01 {
      width: 232px;
      height: 14px;
    }

    .text02 {
      width: 164px;
      height: 14px;
      margin-top: 5px;
    }
  }

  .product-list {
    ${mixin.flex({ justify: 'flex-start', align: 'center' })};
    gap: 0 2px;
    margin-top: 16px;

    .product-item {
      width: 62px;
      height: 83px;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    border-radius: ${mixin.pxToVw('20')};

    .skeleton {
      border-radius: ${mixin.pxToVw('4')};
    }

    .user-info {
      gap: 0 ${mixin.pxToVw('10')};
      padding: ${mixin.pxToVw('14')};

      .user-img {
        width: ${mixin.pxToVw('28')};
        height: ${mixin.pxToVw('28')};
      }

      .user-name {
        width: ${mixin.pxToVw('100')};
        height: ${mixin.pxToVw('16')};
      }
    }

    .shortform-info {
      padding: ${mixin.pxToVw('20')};

      .text01 {
        width: ${mixin.pxToVw('232')};
        height: ${mixin.pxToVw('14')};
      }

      .text02 {
        width: ${mixin.pxToVw('164')};
        height: ${mixin.pxToVw('14')};
        margin-top: ${mixin.pxToVw('5')};
      }
    }

    .product-list {
      gap: 0 ${mixin.pxToVw('2')};
      margin-top: ${mixin.pxToVw('16')};

      .product-item {
        width: ${mixin.pxToVw('62')};
        height: ${mixin.pxToVw('83')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 318px;
    height: 607px;
    border-radius: 24px;

    .user-info {
      padding: 16px;
    }

    .shortform-info {
      padding: 30px;
    }

    .product-list {
      margin-top: 20px;
    }
  }
`;
